import { Component } from '@angular/core';
import { NavController, NavParams, PopoverController, ViewController } from 'ionic-angular';
import { PollProvider } from '../../../../providers/poll/poll';


@Component({
    selector: 'new-sondage',
    templateUrl: 'new-sondage.html',
})
export class NewSondagePage {
    pollInfos: any = {
        type: 2,
        question: '',
        options: [],
        addChoiceText: null,
        isAnonym: false,
        durationDays: 1,
        multiAnswer : false
    }

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        public popoverCtrl: PopoverController,
        public pollProvider: PollProvider,
        public viewCtrl: ViewController,
    ) {
    }

    ngOnInit() {
    }

    submitPoll() {
        let datenow = Math.floor(new Date().getTime() / 1e3);
        let dateend = Math.floor(new Date(new Date().getTime() + this.pollInfos.durationDays * 86400000).getTime() / 1e3); // 86400000 = 24 hours = one day, so this converts duration days to JS date



        const PollVote = {
            question: this.pollInfos.question,
            options: this.pollInfos.options,
            enabled: true,
            type: this.pollInfos.type,
            isAnonym: this.pollInfos.isAnonym,
            starts_at: datenow,
            ends_at: dateend
        }

            this.pollInfos.type == 4 ? PollVote.options = ['cst'] : '';

          this.pollProvider.create(PollVote).subscribe((res) => {
              if(res.success){
                  this.dismiss()
              }
          })
    }


    addChoice(choiceText) {
        choiceText != null ? this.pollInfos.options.push(choiceText) : '';
        this.pollInfos.addChoiceText = null;
    }

    dismiss() {
        this.viewCtrl.dismiss();
    }


}



// WEBPACK FOOTER //
// ./src/pages/employer/sondage/new-sondage/new-sondage.ts